export type ErrorDisplay =
    | { title?: string; message?: string; errorMessage?: string; buttonText?: string; customButton?: JSX.Element | null }
    | { customJSX: JSX.Element };

export class DisplayableError extends Error {
    public constructor(
        public message: string,
        public readonly display: ErrorDisplay,
        public readonly doNotTrack?: boolean,
    ) {
        super(message);
    }
}
